module.exports = __webpack_public_path__ + "assets/img/login_tu4.cc0254b9.png";